export {
  DashboardTravelItineraryIntroduction,
  type DashboardTravelItineraryIntroductionProps,
} from '../../compositions/my-trips/DashboardTravelItineraryIntroduction';
